import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import styles from './MobileHome.module.scss';

/**
 * 모바일 홈 대시보드 컴포넌트
 * - 로그인 후 보여지는 메인 화면
 * - 결재 현황 요약 카드 표시
 */
//TODO: 모바일화면에서만 대시보드를 쓰면 pc화면으로 width가 바뀔경우는 어떤식으로 처리하는지 확인필요함
function MobileHome({ summaryData, userName, onNewDocument }) {
  const navigate = useNavigate();

  // 결재함 카드 데이터
  const approvalCards = [
    {
      id: 'drafter',
      title: '기안문서',
      path: '/approval/drafter',
      pending: summaryData?.drafterPending || 0,
      completed: summaryData?.drafterCompleted || 0,
    },
    {
      id: 'approver',
      title: '결재문서',
      path: '/approval/approver',
      pending: summaryData?.approverPending || 0,
      completed: summaryData?.approverCompleted || 0,
    },
    {
      id: 'reference',
      title: '참조문서',
      path: '/approval/reference',
      pending: summaryData?.referencePending || 0,
      completed: summaryData?.referenceCompleted || 0,
    },
    {
      id: 'execution',
      title: '시행문서',
      path: '/approval/execution',
      pending: summaryData?.executionPending || 0,
      completed: summaryData?.executionCompleted || 0,
    },
  ];

  function handleCardClick(path) {
    navigate(path);
  }

  return (
    <div className={styles.container}>
      {/* 환영 메시지 */}
      <section className={styles.welcomeSection}>
        <h2 className={styles.welcomeTitle}>
          안녕하세요, <span className={styles.userName}>{userName}</span>님
        </h2>
        <p className={styles.welcomeSubtitle}>오늘도 좋은 하루 되세요!</p>
      </section>

      {/* 새문서 작성 버튼 */}
      <button type="button" className={styles.newDocumentButton} onClick={onNewDocument}>
        <span className={styles.plusIcon} />
        <span className={styles.buttonText}>새문서 작성</span>
      </button>

      {/* 결재 현황 카드 */}
      <section className={styles.cardSection}>
        <h3 className={styles.sectionTitle}>결재 현황</h3>
        <div className={styles.cardGrid}>
          {approvalCards.map((card) => (
            <button
              key={card.id}
              type="button"
              className={styles.card}
              onClick={() => handleCardClick(card.path)}
            >
              <span className={styles.cardTitle}>{card.title}</span>
              <div className={styles.cardStats}>
                <div className={styles.statItem}>
                  <span className={styles.statLabel}>대기</span>
                  <span className={styles.statValue}>{card.pending}</span>
                </div>
                <div className={styles.statDivider} />
                <div className={styles.statItem}>
                  <span className={styles.statLabel}>완료</span>
                  <span className={styles.statValueCompleted}>{card.completed}</span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </section>

      {/* 빠른 메뉴 */}
      <section className={styles.quickMenuSection}>
        <h3 className={styles.sectionTitle}>빠른 메뉴</h3>
        <div className={styles.quickMenuGrid}>
          <button
            type="button"
            className={styles.quickMenuItem}
            onClick={() => navigate('/approval/temporary-archive')}
          >
            <span className={styles.quickMenuIcon}>📁</span>
            <span className={styles.quickMenuText}>임시보관함</span>
          </button>
          <button
            type="button"
            className={styles.quickMenuItem}
            onClick={() => navigate('/approval/vacation/request')}
          >
            <span className={styles.quickMenuIcon}>🌴</span>
            <span className={styles.quickMenuText}>휴가신청</span>
          </button>
          <button
            type="button"
            className={styles.quickMenuItem}
            onClick={() => navigate('/approval/settings/sign')}
          >
            <span className={styles.quickMenuIcon}>✍️</span>
            <span className={styles.quickMenuText}>서명설정</span>
          </button>
        </div>
      </section>
    </div>
  );
}

MobileHome.propTypes = {
  summaryData: PropTypes.shape({
    drafterPending: PropTypes.number,
    drafterCompleted: PropTypes.number,
    approverPending: PropTypes.number,
    approverCompleted: PropTypes.number,
    referencePending: PropTypes.number,
    referenceCompleted: PropTypes.number,
    executionPending: PropTypes.number,
    executionCompleted: PropTypes.number,
  }),
  userName: PropTypes.string,
  onNewDocument: PropTypes.func,
};

MobileHome.defaultProps = {
  summaryData: {},
  userName: '사용자',
  onNewDocument: () => {},
};

export default MobileHome;
